import { useId } from 'react';
import './createWorldSteps.css';

/** Toggle that reveals optional fields on builder steps. */
export function OptionalQuestionsToggle(props: {
  open: boolean;
  onToggle: () => void;
}): JSX.Element {
  return (
    <button
      type="button"
      className="btn-ghost world-optional-toggle"
      aria-expanded={props.open}
      onClick={props.onToggle}
    >
      + optional questions
    </button>
  );
}

/** In-page Yes/No prompt when Continue hits unanswered optional fields. */
export function OptionalContinueDialog(props: {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
}): JSX.Element | null {
  const titleId = useId();
  if (!props.open) return null;
  return (
    <div className="world-ai-fill-dialog" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <div className="world-ai-fill-dialog-card">
        <h2 id={titleId} className="world-ai-fill-title">Optional questions</h2>
        <p>Would you like the AI to fill the optional questions?</p>
        <div className="world-action-row">
          <button type="button" className="btn-primary" onClick={props.onYes}>Yes</button>
          <button type="button" className="btn-ghost" onClick={props.onNo}>No</button>
        </div>
      </div>
    </div>
  );
}
